// eslint-disable-next-line boundaries/element-types -- FIXME
import type { OfferSelectOption } from '@core/offers-ui';
import type { Placement, PlacementBase } from '@core/placements-types';

export type RequiredPlacementProps = Pick<PlacementBase, 'ratingVisible'>;

export const isPlacementHidden = (placement: RequiredPlacementProps) =>
  placement.ratingVisible === false;

export const isAnyPlacementHidden = (placements: RequiredPlacementProps[]) =>
  placements.some(isPlacementHidden);

export function offerSelectOptionsFromPlacements(placements: Placement[]): OfferSelectOption[] {
  return <OfferSelectOption[]>placements?.map(placement => {
      const { offer, talentPool } = placement;
      return {
        id: (offer || talentPool)!.id,
        title: (offer || talentPool)!.title,
        kind: (offer || talentPool)!.kind,
        status: (offer || talentPool)!.status,
      };
    }) ?? [];
}

export function offerIdsFromPlacements(placements: Placement[]): number[] {
  return placements.map(placement => (placement.offer || placement.talentPool)!.id);
}
